module.exports = __webpack_public_path__ + "img/it_it_day-9.75b26285.svg";